export enum TdpEnum {
  STATUS_1_BLOQUE = "PARTICULIER_BLOQUE",
  STATUS_2_EC = "APPAREILLAGE_EC",
  STATUS_3_NF = "APPAREILLAGE_NF",
  STATUS_3_VALIDE = "APPAREILLAGE_VALIDE",
  STATUS_4_ERROR = "ERROR",
  STATUS_5_MANDAT_ECHU = "MANDAT_ECHU",
}

export enum TdpDescEnum {
  STATUS_1_BLOQUE = "Transmission de demande de paiement impossible, compte du particulier bloqué dû à un défaut de paiement. Le compte est bloqué pendant 29 jours à compter du refus de prélèvement.",
  STATUS_2_EC = "Transmission de déclaration de paiement impossible, appareillage en cours de traitement",
  STATUS_3_NF = "Transmission de déclaration de paiement impossible, appareillage non finalisé (Non prise de connaissance des CGU ou appareillage en attente de validation)\n Note : Dans ce cas, une action du particulier est attendue pour finaliser l’appareillage. Votre client doit valider le lien reçu par mail de la part de l'URSSAF. Il faut vérifier dans les SPAMs s'il ne s'y trouve pas. S'il ne parvient pas à récupérer le lien, il peut en faire une nouvelle demande depuis le site https://www.particulier.urssaf.fr/#/lien-activation-compte",
  STATUS_3_VALIDE = "Votre élève a activé son compte URSSAF. Vous pouvez déclarer vos cours avec lui sur Teach’r.",
  STATUS_4_ERROR = "⚠️ Aucun client actif trouvé. Il est possible que cette personne ait résilié son inscription auprès de ce prestataire.",
  STATUS_5_DEFAULT = "Veuillez actualiser le statut de transmission de paiement",
  STATUS_6_ACTIVE_DEFAULT = "Merci de contacter le service client afin qu'il puisse valider le compte de votre élève, vous permettant ainsi de déclarer un cours avec lui.",
  STATUS_5_MANDAT_ECHU = "Le mandat SEPA de ce client est arrivé à échéance. Aucun prélèvement ne peut être effectué sans un mandat valide",
}

const colorClasses = {
  ALERT: "text-third border-orange bg-orange bg-opacity-10",  // Alerte / Blocage
  WARNING: "text-yellow-500 border-yellow-500 bg-yellow-500 bg-opacity-10",  // En attente / En cours
  INFO: "text-blue-400 border-blue-400 bg-blue-400 bg-opacity-10",  // Infos administratives
  INFO_LIGHT: "text-blue-300 border-blue-300 bg-blue-300 bg-opacity-10",  // Infos administratives
  SUCCESS_LIGHT: "text-green-400 border-green-400 bg-green-400 bg-opacity-10",  // Succès léger
  SUCCESS_DARK: "text-green-600 border-green-600 bg-green-600 bg-opacity-10",  // Succès validé
  ERROR: "text-red-500 border-red-500 bg-red-500 bg-opacity-10",  // Erreur critique
};

export const TdpEnumColor = {
  STATUS_1_BLOQUE: { title: 'Bloqué', etat : "KO",color: colorClasses.ALERT }, // 🟠 Orange pour un compte bloqué
  STATUS_2_EC: { title: 'En attente', etat : "KO",color: colorClasses.WARNING }, // 🟡 Jaune pour un processus en attente
  STATUS_3_NF: { title: 'Non finalisé', etat : "KO",color: colorClasses.INFO }, // 🔵 Bleu clair pour des étapes admin en attente
  STATUS_3_VALIDE: { title: 'Validé', etat : "OK",color: colorClasses.SUCCESS_DARK }, // 🟢 Vert foncé car le compte est validé !
  STATUS_4_ERROR: { title: 'Erreur', etat : "",color: colorClasses.ERROR }, // 🔴 Rouge pour une erreur inconnue
  STATUS_5_DEFAULT: { title: 'En cours', etat : "KO",color: colorClasses.INFO_LIGHT },
  STATUS_5_MANDAT_ECHU: { title: 'Expiré', etat : "KO",color: colorClasses.ALERT }
};
